import { LOCAL_STORAGE_KEYS } from '@shared/constants';

// FIXME: tokens config goes here according to api requirement
export enum TOKENS {
  accessToken = 'X-Access-Token',
  refreshToken = 'X-Refresh-Token',
}

export interface TokenConfig {
  refreshToken: string;
  accessToken: string;
}

// FIXME: tokens config goes here according to api requirement
export enum TOKENS_AUTH {
  twoFactorAuthToken = 'TFA-ACCESS-TOKEN',
  twoFactorAuthQrCode = 'TFA-ACCESS-QR-CODE',
  twoFactorAuthSecretKey = 'TFA-ACCESS-SECRET-KEY',
}

export type LocalStorageKeyType = keyof typeof LOCAL_STORAGE_KEYS;
